// src/api/axiosInstance.js
import axios from "axios";

// Create an Axios instance
const axiosInstance = axios.create({
  baseURL: "https://api.cansunsari.org.np/dspro/api",
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor: add auth token
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("authToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

// Response interceptor: handle unauthorized globally
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Remove token and role from localStorage
      localStorage.removeItem("authToken");
      localStorage.removeItem("role");
      // Redirect to login page
      window.location.href = "/";
    }
    return Promise.reject(error);
  },
);

export default axiosInstance;
